"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setError = exports.setIsLoggingOut = exports.setIsLoaded = exports.setIsSigningIn = exports.setIsAuthenticated = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var login_model_1 = require("../models/login.model");
var loginSlice = (0, toolkit_1.createSlice)({
    name: 'login',
    initialState: (0, login_model_1.loginStateFactory)(),
    reducers: {
        setIsAuthenticated: function (state, action) {
            state.isAuthenticated = action.payload;
            state.isLoggingOut = false;
        },
        setIsLoaded: function (state, action) {
            state.isLoaded = action.payload;
        },
        setIsSigningIn: function (state, action) {
            state.isSigningIn = action.payload;
        },
        setIsLoggingOut: function (state) {
            state.isLoggingOut = true;
        },
        setError: function (state, action) {
            state.error = action.payload;
        },
    },
});
var actions = loginSlice.actions, reducer = loginSlice.reducer;
exports.setIsAuthenticated = actions.setIsAuthenticated, exports.setIsSigningIn = actions.setIsSigningIn, exports.setIsLoaded = actions.setIsLoaded, exports.setIsLoggingOut = actions.setIsLoggingOut, exports.setError = actions.setError;
exports.default = reducer;
